module.exports = __webpack_public_path__ + "static/img/bg-en.f41fbf2a.png";